import { type UseGetQueryOptions } from "@src/appV2/api";
import { type FacilityProfile } from "@src/appV2/Facilities/types";

import { useFacilityProfile } from "./useFacilityProfile";

export function useGetCredentialSharingConfiguration(
  workplaceId: string,
  options?: UseGetQueryOptions<FacilityProfile>
) {
  const { data: facilityProfile, isLoading } = useFacilityProfile(
    {
      workplaceId,
      projection: "credentialSharingConfiguration",
    },
    options
  );

  const credentialSharingConfiguration = facilityProfile?.credentialSharingConfiguration;

  return {
    credentialSharingConfiguration,
    isLoading,
  };
}
